import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, filter, lastValueFrom, takeUntil } from 'rxjs';
import {
  MaterialSubGroup,
  MaterialGroup,
  Brand,
  UOM,
  Currency,
  CostCentre,
  GLAccount,
  FundCentre,
  KeycloakUser,
  KeycloakNoUser,
  DeliveryAddressI,
  ReasonForNotUsingRFQ,
} from './shared/models/database-models';
import uomData from '../app/data/constants/UOM.json';
import { storeGenericDropDownOptions } from './core/store/dropDown.actions';
import { BackendApiService } from './core/services/backend-api';
import {
  ExtendedAttachmentType,
  ExtendedGLAccount,
  ExtendedKeycloakUser,
  ExtendedMaterialGroup,
  ExtendedMaterialSubGroup,
  StoreDropdowns,
  UserInformation,
} from './shared/models/app-models';
import { DropDownOptions } from './shared/models/app-models/DropDownOption.model';
import { AttachmentType } from './shared/models/database-models/AttachmentInfo.model';
import { KeycloakUserService } from './shared/services/keycloakuser.service';
import { KeycloakService } from 'keycloak-angular';
import { updateLoggedInUser } from './core/store/UserInfo.action';
import { KeycloakADUser } from './shared/models/database-models/KeycloakADUser';
import { PermissibleReason } from './shared/models/app-models/PermissibleReason.model';
import { ExtendedReasonForNotUsingRFQ } from './shared/models/app-models/ExtendedReasonForNotUsingRFQ.model';
import { PermissionsService } from './core/services/permissions/permission.service';
import { MP_ROLE_PREFIX } from './data/constants/Data';
import { isEqual } from 'lodash';
import { AbilityField } from './core/services/permissions/AppAbility';
import { ExtendedDOTPReason } from './shared/models/app-models/ExtendedDOTPReason.model';
import { EstimatedUsages } from './shared/models/database-models/EstimatedUsages.model';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DatePipe]
})
export class AppComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  title = 'front-end';
  description = 'asdnasdjas';
  showMenuBar = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  readonly permissionData$: Observable<any>;
  isSubMenuOpen: boolean = false;
  isLinksSubMenuOpen:boolean =false;
  currentRoute: string = '';
  maintenanceMessage: string = '';
  showGlobalNotification: boolean = false;
  constructor(
    private router: Router,
    private store: Store<{ dp: StoreDropdowns; user: UserInformation }>,
    private BackendApi: BackendApiService,
    private keyCloakService: KeycloakService,
    private keyCloakUserService: KeycloakUserService,
    private permissionsService: PermissionsService,
    private datePipe: DatePipe
  ) {
    this.permissionData$ = permissionsService.getService().pipe(takeUntil(this.destroy$))
  }

  async ngOnInit(): Promise<void> {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentRoute = this.router.url;
    });
    try {
      const data = await this.getDropDownData();
      let user: UserInformation = {
        userName: this.keyCloakService.getUsername(),
        token: await this.keyCloakService.getToken(),
        fullName: (await this.keyCloakService.loadUserProfile()).lastName ?? '',
        roles: this.keyCloakService.getUserRoles().filter(x => x.startsWith(MP_ROLE_PREFIX))
      };

      console.log(user);

      this.store.dispatch(updateLoggedInUser({ user: user }));
      this.store.dispatch(
        storeGenericDropDownOptions({ dropdownOptions: data })
      );
      const bannerClosed = sessionStorage.getItem('globalMessageClosed');
      if (!bannerClosed)
        this.getMaintenanceMessage();
    } catch (e) {
      console.log(e);
    }
  }

  checkActiveRoute() {
    if (this.currentRoute.includes('/reports') || this.currentRoute.includes('/rfqReports')) {
      this.isSubMenuOpen = true;
    } else{
      this.isSubMenuOpen=false;
    }
  }

  // Method to toggle the sub-menu
  toggleSubMenu() {
    this.isSubMenuOpen = !this.isSubMenuOpen;
  }

  toggleLinksSubMenu() {
    this.isLinksSubMenuOpen = !this.isLinksSubMenuOpen;
  }

  async getUsers(): Promise<ExtendedKeycloakUser[]> {
    try {
      let token = await lastValueFrom(
        this.keyCloakUserService.getAdminToken().pipe(takeUntil(this.destroy$))
      );

      //new to support OA

      let userList!: KeycloakADUser[];

      userList = await lastValueFrom(this.keyCloakUserService.getAllKeycloakADUsers());

      // let numberOfKCUser: KeycloakNoUser = await lastValueFrom(
      //   this.keyCloakUserService
      //     .getNumberOfUsers(token.access_token)
      //     .pipe(takeUntil(this.destroy$))
      // );

      // console.log('number of kc users :' + numberOfKCUser.noOfUser);
      // for (var i = 0; i < numberOfKCUser.noOfUser; i += 100) {
      //   var usernames = await lastValueFrom(
      //     this.keyCloakUserService
      //       .getKeycloakUsers(token.access_token, i.toString())
      //       .pipe(takeUntil(this.destroy$))
      //   );
      //   console.log('check here: ', usernames);
      //   if (userList === undefined) userList = [...usernames];
      //   else {
      //     userList = userList.concat(usernames);

      //     console.log(userList);
      //   }
      // }

      // let usernames: KeycloakUser[] = await lastValueFrom(
      //   this.keyCloakUserService
      //     .getKeycloakUsers(token.access_token, '0')
      //     .pipe(takeUntil(this.destroy$))
      // );
      let extendedUsernames: ExtendedKeycloakUser[] = userList.map(
        (user: KeycloakADUser) => {
          return { ...user, id: user.username, value: user.last_name };
        }
      );
      return extendedUsernames;
    } catch (e) {
      return [];
    }
  }
  async getDropDownData() {
    //retrieve permissible reasons data
    let permissibleReasondropDown: DropDownOptions[] = [];
    let permissibleReasonData: PermissibleReason[] = await lastValueFrom(
      this.BackendApi.retrievePermissibleReasons().pipe(takeUntil(this.destroy$))
    );
    permissibleReasonData.forEach((option: PermissibleReason) => {
      permissibleReasondropDown.push({ id: option.id, value: option.Reason });
    });

    // retrieve MG/MSG data
    let subMgData: MaterialSubGroup[] = await lastValueFrom(
      this.BackendApi.retrieveSubMG().pipe(takeUntil(this.destroy$))
    );
    const subMgOptions: ExtendedMaterialSubGroup[] = [];
    subMgData.forEach((option: MaterialSubGroup) => {
      let obj = { ...option, id: option.Code, value: option.Name };
      subMgOptions.push(obj);
    });

    let mgData: MaterialGroup[] = await lastValueFrom(
      this.BackendApi.retrieveMG().pipe(takeUntil(this.destroy$))
    );
    const mgOptions: ExtendedMaterialGroup[] = [];

    mgData.forEach((option: MaterialGroup) => {
      let obj = { ...option, id: option.Code, value: option.Name };
      mgOptions.push(obj);
    });

    let reasonForNotUsingRFQData: ReasonForNotUsingRFQ[] = await lastValueFrom(
      this.BackendApi.getReasonsForNotUsingRFQ().pipe(takeUntil(this.destroy$))
    );
    const reasonForNotUsingRFQOptions: ExtendedReasonForNotUsingRFQ[] = reasonForNotUsingRFQData.filter(data => data.Name && data.Code).map((data) => {
      return { ...data, id: data.Code, value: data.Code };
    });

    let oemData: Brand[] = await lastValueFrom(
      this.BackendApi.getBrands().pipe(takeUntil(this.destroy$))
    );
    const oemOptions: DropDownOptions[] = [];
    // console.log("here: ", oemData);
    oemData.forEach((option: Brand) => {
      let obj = { id: option.Code, value: option.Name };
      oemOptions.push(obj);
    });

    let costCentreData: CostCentre[] = await lastValueFrom(
      this.BackendApi.getCostCentre().pipe(takeUntil(this.destroy$))
    );
    const costCentreOptions: DropDownOptions[] = [];
    // console.log('cost centre data: ', costCentreData);
    costCentreData.forEach((option: CostCentre) => {
      let obj = { id: option.Code, value: option.Name };
      costCentreOptions.push(obj);
    });

    let glAccData: GLAccount[] = await lastValueFrom(
      this.BackendApi.getGLAccount().pipe(takeUntil(this.destroy$))
    );
    const glAccOptions: ExtendedGLAccount[] = [];
    glAccData.forEach((option: GLAccount) => {
      let obj = { ...option, id: option.Code, value: option.Name };
      glAccOptions.push(obj);
    });

    let currencyData: Currency[] = await lastValueFrom(
      this.BackendApi.getCurrecies().pipe(takeUntil(this.destroy$))
    );
    const currencyOptions: DropDownOptions[] = [];
    currencyData.forEach((option: Currency) => {
      let obj = { id: option.Code, value: option.NAME };
      currencyOptions.push(obj);
    });

    let fundCentre: FundCentre[] = await lastValueFrom(
      this.BackendApi.getFundCentres().pipe(takeUntil(this.destroy$))
    );
    const fundCentreOptions: DropDownOptions[] = [];
    fundCentre.forEach((option: FundCentre) => {
      let obj = { id: option.Code, value: option.Name };
      fundCentreOptions.push(obj);
    });

    uomData.sort((a, b) => (a.Name > b.Name ? 1 : -1));
    let UOMdropdown: DropDownOptions[] = [];
    uomData.forEach((option: UOM) => {
      if (option.IsActive === '1') {
        let record = { id: option.ID.toString(), value: option.Name };
        UOMdropdown.push(record);
      }
    });

    let projectCode: any = await lastValueFrom(
      this.BackendApi.getProjectCode().pipe(takeUntil(this.destroy$))
    );
    const projectCodeOptions: any = [];
    projectCode.forEach((option: any) => {
      let ddOption = {
        ProjectCode: option.project,
        ProjectName: option.ProjectName,
        id: option.project,
        value: option.ProjectName,
      };
      projectCodeOptions.push(ddOption);
    });
    let projectBudget: any = await lastValueFrom(
      this.BackendApi.getProjectBudget().pipe(takeUntil(this.destroy$))
    );
    const projBudgetOptions: any = [];
    projectBudget.forEach((option: any) => {
      let ddOption = { ...option, id: option.Code, value: option.Name };
      projBudgetOptions.push(ddOption);
    });

    let wocReasons = await lastValueFrom(
      this.BackendApi.getWocReasons().pipe(takeUntil(this.destroy$))
    );
    let dotpReasons: ExtendedDOTPReason[] = await lastValueFrom(
      this.BackendApi.getDotpReasons().pipe(takeUntil(this.destroy$))
    );
    //shift other reason to end of array
    let otherReasonIndex = dotpReasons.findIndex(x => x.code?.toLowerCase().includes('other'))

    if (otherReasonIndex >= 0) {
      let otherReason = dotpReasons[otherReasonIndex]
      dotpReasons.splice(otherReasonIndex, 1);
      dotpReasons = [...dotpReasons, otherReason];
    }
    let blankReasonIndex = dotpReasons.findIndex(x => x.Reason === null || x.Reason.trim() === '')
    if (blankReasonIndex >= 0) {
      let blankReason = dotpReasons[blankReasonIndex];
      dotpReasons.splice(blankReasonIndex, 1);
      dotpReasons = [blankReason, ...dotpReasons];
    }

    // let projectCodeOptions = [{
    //     id: '1',
    //     value: 'Project code 1'
    //   }, {
    //     id: '2',
    //     value: 'Project code 2'
    // }];

    // let projectOptions = [
    //   {
    //     id: '1',
    //     value: 'Project One',
    //   },
    //   {
    //     id: '2',
    //     value: 'Project Two',
    //   },
    //   {
    //     id: '3',
    //     value: 'Project Three',
    //   }
    // ];

    let attachmentInfo = await lastValueFrom(
      this.BackendApi.getAttachmentInfo().pipe(takeUntil(this.destroy$))
    );
    let ROAttachmentTypeOptions: ExtendedAttachmentType[] =
      attachmentInfo.attachmentType.RO.map((info: AttachmentType) => {
        return {
          ...info,
          id: info.AttachmentTypeId.toString(),
          value: info.Name,
        };
      });
    let CEAttachmentTypeOptions: ExtendedAttachmentType[] =
      attachmentInfo.attachmentType.CE.map((info: AttachmentType) => {
        return {
          ...info,
          id: info.AttachmentTypeId.toString(),
          value: info.Name,
        };
      });
    let attachmentExtensionOptions = attachmentInfo.AttachmentExtensions;
    let UserListOptions: ExtendedKeycloakUser[] = await this.getUsers();
    const addressList: DeliveryAddressI[] = await lastValueFrom(
      this.BackendApi.getDeliveryAddress());
    const addressOptions: DropDownOptions[] = [
      ...addressList.map((address: DeliveryAddressI) => {
        return { id: address.ID + '', value: address.Name || '' };
      }),
      { id: 'others', value: 'Others' },
    ];

    let estimatedUsages: EstimatedUsages[] = await lastValueFrom(
      this.BackendApi.getEstimatedUsages().pipe(takeUntil(this.destroy$))
    );
    let abortRFQSummaryReasons = await lastValueFrom(
      this.BackendApi.getAbortReasons()
    );
    let finalObject: StoreDropdowns = {
      UserList: UserListOptions,
      CostCentre: costCentreOptions,
      UOM: UOMdropdown,
      OEM: oemOptions,
      GLAcc: glAccOptions,
      Currency: currencyOptions,
      MaterialGroup: mgOptions,
      MaterialSubGroup: subMgOptions,
      ProjectCode: projectCodeOptions,
      ProjectBudget: projBudgetOptions,
      FundCentre: fundCentreOptions,
      ROAttachmentType: ROAttachmentTypeOptions,
      CEAttachmentType: CEAttachmentTypeOptions,
      AttachmentExtensions: attachmentExtensionOptions,
      DeliveryAddress: addressOptions,
      WOCReasons: wocReasons,
      PermissibleReason: permissibleReasondropDown,
      DOTPReasons: dotpReasons,
      ReasonForNotUsingRFQ: reasonForNotUsingRFQOptions,
      EstimatedUsages: estimatedUsages,
      RFQAbortReasons:abortRFQSummaryReasons
    };

    return finalObject;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  sidebarToggle() {
    this.sidenav.toggle();
  }

  navigateToPurchaseMode() {
    this.router.navigateByUrl('/home');
    this.sidenav.toggle();
  }

  navigateToLandingPage() {
    this.router.navigateByUrl('/land');
    this.sidenav.toggle();
  }

  navigateToWorklistPage() {
    this.router.navigateByUrl('/worklist');
    this.sidenav.toggle();
  }

  navigateToPEReportsPage() {
    this.router.navigateByUrl('/reports');
    this.sidenav.toggle();
  }

  navigateToRFQReportsPage() {
    this.router.navigateByUrl('/rfqReports');
    this.sidenav.toggle();
  }

  public get AbilityField(): typeof AbilityField {
    return AbilityField
  }

  async getMaintenanceMessage() {
    const today = new Date();
    const formattedDate = this.datePipe.transform(today, 'yyyy-MM-dd')!;
    let data: any = await lastValueFrom(
      this.BackendApi.getMaintenanceMessage(formattedDate).pipe(takeUntil(this.destroy$))
    );
    if (data.length > 0) {
      let msg = data[0].Message;
      this.maintenanceMessage = msg;
      this.showGlobalNotification = true;
    }
  }

  onCloseGlobalNotification() {
    this.showGlobalNotification = false;
    sessionStorage.setItem('globalMessageClosed', 'true');
  }

  navigateToPPC() {
    const url = environment.pastPurchaseChecker;
    window.open(url, '_blank');
  }

  navigateToPriceAgreements() {
    const url = environment.priceAgreement;
    window.open(url, '_blank');
  }

  goToMMS() {
    const url = environment.mmsURL;
    window.open(url, '_blank');
  }
}
